import {
	AfterContentInit,
	booleanAttribute,
	Directive,
	ElementRef,
	Inject,
	Input,
	numberAttribute,
	OnInit,
	ViewContainerRef,
} from "@angular/core";
import { MatAccordion, MatExpansionPanelHeader } from "@angular/material/expansion";
import { cnList } from "@app/_helpers/utils";
import { AppService } from "@app/app.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { startWith } from "rxjs";
@UntilDestroy()
@Directive({
	selector: "mat-accordion[matExpandableCards],mat-expansion-panel[mat-expandable-cards]",
})
export class MatExpandableCardsDirective implements OnInit, AfterContentInit {
	constructor(
		private viewContainer: ViewContainerRef,
		private elRef: ElementRef,
		private appService: AppService,
		@Inject(MatAccordion)
		private matAccordion: MatAccordion
	) {}
	@Input({ alias: "mat-expandable-cards", transform: booleanAttribute })
	matExpandableCards: boolean = true;

	@Input({ transform: numberAttribute })
	fixedHeight: number = 58;

	@Input({ transform: booleanAttribute })
	rounded: boolean = false;

	private initializedPanelIds: Set<string> = new Set();
	ngOnInit() {
		this.initializedPanelIds.clear();
	}
	private classes = {
		expanded: "mat-bd-5 mat-bg-card-3 mb-4",
		collapsed: "shadow-none mat-elevation-z0",
		card: "mat-expansion-card",
		accordion: "mat-accordion-cards",
		accordionRounded: "mat-accordion-cards mat-accordion-rounded",
	} as const;
	ngAfterContentInit() {
		this.viewContainer.element.nativeElement.classList.add(
			...cnList(this.rounded ? this.classes.accordionRounded : this.classes.accordion)
		);
		this.matAccordion._headers.changes.pipe(untilDestroyed(this), startWith(Date.now())).subscribe(() => {
			const value = this.matAccordion._headers.toArray();
			value
				.filter((d) => d.panel.id && !this.initializedPanelIds.has(d.panel.id))
				.forEach((header: MatExpansionPanelHeader) => {
					const panel = header.panel;
					this.initializedPanelIds.add(panel.id);
					const viewRef: ViewContainerRef = panel["_viewContainerRef"];

					header.collapsedHeight = `${this.fixedHeight}px`;
					header.expandedHeight = `${this.fixedHeight}px`;
					viewRef.element.nativeElement.classList.add(
						...cnList(this.classes.card, panel.expanded ? this.classes.expanded : this.classes.collapsed)
					);
					panel.expandedChange.subscribe((expanded: boolean) => {
						if (expanded) {
							viewRef.element.nativeElement.classList.remove(...cnList(this.classes.collapsed));
							viewRef.element.nativeElement.classList.add(...cnList(this.classes.expanded));
						} else {
							viewRef.element.nativeElement.classList.remove(...cnList(this.classes.expanded));
							viewRef.element.nativeElement.classList.add(...cnList(this.classes.collapsed));
						}
					});
				});
		});
	}
}
